import { lazy } from 'react';

export const LazyTemplateConverterPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--template-converter-page" */ './template-converter-page'
    ),
);
